import useEventListener from '../use-event-listener/use-event-listener';
export default function useClick() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    onClick = _ref.onClick,
    _ref$once = _ref.once,
    once = _ref$once === void 0 ? false : _ref$once;
  useEventListener('click', onClick, {
    once: once
  });
  return {};
}